import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection/WebViewDetails";
import { detectWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
import { inEnum, isArrayOf, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";

export enum PosterFormat {
    BIG = "big",
    MEDIUM = "medium",
    SMALL = "small"
}

interface PosterFormatResource {
    format: PosterFormat,
    url: string
}

export function isPosterFormatResource(obj: any): obj is PosterFormatResource {
    return isObject(obj) &&
        (hasOwnProperty(obj, 'format') && inEnum(obj['format'], PosterFormat)) &&
        (hasOwnProperty(obj, 'url') && isString(obj['url']))
}

export type ThumbnailResource = string | PosterFormatResource[];


export function isThumbnailResource(obj: any): obj is ThumbnailResource {
    return isString(obj) || isArrayOf(obj, isPosterFormatResource)
}

export function getPosterUrl(thumbnail?: ThumbnailResource, wvIn?: DetectedWebView, preferredPosterFormat?: PosterFormat): string | null {

    if (!thumbnail)
        return;

    if (isString(thumbnail)) {
        return thumbnail;
    } else if(isArrayOf(thumbnail, isPosterFormatResource)){
        const wv = wvIn ? wvIn : detectWebView();
        const big = thumbnail.find(p => p.format == PosterFormat.BIG)
        const medium = thumbnail.find(p => p.format == PosterFormat.MEDIUM)
        const small = thumbnail.find(p => p.format == PosterFormat.SMALL)
        
        
        if(preferredPosterFormat) {
            return thumbnail.find(p => p.format == preferredPosterFormat)?.url
        } else if (wv.device?.other) {
            const url = medium ? medium.url : (small ? small.url : big?.url )
            return url;
        } else {
            const url = small ? small.url : (medium ? medium.url : big?.url )
            return url;
        }
    }
    return
}
